import { FC } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { VideoLibrary } from '@mui/icons-material';

interface ProcessingMessageProps {
  isVisible: boolean;
  message?: string;
  type?: 'video' | 'audio';
  variant?: 'overlay' | 'inline';
}

const ProcessingMessage: FC<ProcessingMessageProps> = ({
  isVisible,
  message = 'Your video is being processed and trimmed. This may take a few minutes...',
  type = 'video',
  variant = 'overlay',
}) => {
  if (!isVisible) {
    return null;
  }

  const icon = type === 'video' ? <VideoLibrary /> : undefined;

  if (variant === 'inline') {
    return (
      <Alert
        severity="info"
        icon={icon}
        sx={{
          backgroundColor: 'rgba(33, 150, 243, 0.9)',
          border: '1px solid rgba(33, 150, 243, 0.5)',
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          },
          '& .MuiAlert-icon': {
            color: 'white',
          },
          color: 'white',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <CircularProgress size={16} sx={{ color: 'white' }} />
          <Typography variant="body2" sx={{ fontWeight: 500, color: 'white' }}>
            {message}
          </Typography>
        </Box>
      </Alert>
    );
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        borderRadius: 'inherit',
      }}
    >
      <Alert
        severity="info"
        icon={icon}
        sx={{
          backgroundColor: 'rgba(33, 150, 243, 0.9)',
          border: '1px solid rgba(33, 150, 243, 0.5)',
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          },
          '& .MuiAlert-icon': {
            color: 'white',
          },
          color: 'white',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <CircularProgress size={16} sx={{ color: 'white' }} />
          <Typography variant="body2" sx={{ fontWeight: 500, color: 'white' }}>
            {message}
          </Typography>
        </Box>
      </Alert>
    </Box>
  );
};

export default ProcessingMessage;
